export function getDOMInlinedDataElement(aUrl: string): HTMLElement
{
    let element = document.getElementById(aUrl);
    if (!element) {
        return null;
    }

    return element;
}

export function getDOMInlinedImage(aUrl: string): string
{
    let dataElement = document.getElementById(aUrl);
    if (dataElement) {
        let base64Data = dataElement.getAttribute('base64data');
        if (base64Data) {
            let extIndex = aUrl.lastIndexOf(".");
            if (extIndex !== -1) {
                return "data:image/" + aUrl.substring(extIndex + 1) + ";base64," + base64Data;
            }
            else {
                return "data:image/jpeg;base64," + base64Data;
            }
        }
    }

    return null;
}

export function inURLBinaryData(): string {
    return "data:binary;base64,";
}

export function isRelative(url: string): boolean {
    return url.indexOf("http") === -1 &&
        url.indexOf("base64,") === -1 &&
        url[0] !== '/' &&
        url[0] !== '\\' &&
        url.indexOf("@assets") === -1;
}

export function isPointingToOrigin(url: string): boolean {
    return url[0] === '/' || url[0] === '\\';
}
